import React from "react";
import "./expansionFootageProgressBar.css";

export default function ExpansionDailyProgressForm({
  conduitFootage,
  fiberFootage,
  proofingFootage,
  vaults,
  notes,
  onConduitFootageChange,
  onFiberFootageChange,
  onProofingFootageChange,
  onVaultsChange,
  onNotesChange,
  disabled = false,
  idPrefix = "expansion-daily",
  vaultsLabel = "Handholes installed",
}) {
  return (
    <div className="expansion-daily-progress-form">
      <div className="expansion-daily-progress-form-grid">
        <label className="phase-schedule-field">
          <span className="phase-schedule-field-label">Conduit installed (ft)</span>
          <input
            id={`${idPrefix}-conduit`}
            className="commercial-field-input"
            type="number"
            min="0"
            step="any"
            value={conduitFootage}
            disabled={disabled}
            onChange={(e) => onConduitFootageChange?.(e.target.value)}
          />
        </label>
        <label className="phase-schedule-field">
          <span className="phase-schedule-field-label">Fiber installed (ft)</span>
          <input
            id={`${idPrefix}-fiber`}
            className="commercial-field-input"
            type="number"
            min="0"
            step="any"
            value={fiberFootage}
            disabled={disabled}
            onChange={(e) => onFiberFootageChange?.(e.target.value)}
          />
        </label>
        <label className="phase-schedule-field">
          <span className="phase-schedule-field-label">Proofing completed (ft)</span>
          <input
            id={`${idPrefix}-proofing`}
            className="commercial-field-input"
            type="number"
            min="0"
            step="any"
            value={proofingFootage}
            disabled={disabled}
            onChange={(e) => onProofingFootageChange?.(e.target.value)}
          />
        </label>
        <label className="phase-schedule-field">
          <span className="phase-schedule-field-label">{vaultsLabel}</span>
          <input
            id={`${idPrefix}-vaults`}
            className="commercial-field-input"
            type="number"
            min="0"
            step="1"
            value={vaults}
            disabled={disabled}
            onChange={(e) => onVaultsChange?.(e.target.value)}
          />
        </label>
        <label className="phase-schedule-field phase-schedule-field--full">
          <span className="phase-schedule-field-label">Progress notes</span>
          <textarea
            id={`${idPrefix}-notes`}
            className="commercial-field-input"
            rows={3}
            value={notes}
            disabled={disabled}
            placeholder="Weather delays, blockages, crew notes…"
            onChange={(e) => onNotesChange?.(e.target.value)}
          />
        </label>
      </div>
    </div>
  );
}
